// 报名期调试 mock — 仅本地开发用, 与业务逻辑解耦
//
// 触发条件: localhost / 127.0.0.1 且 URL 带 ?mockApply=ABC (三位数, 不足左侧补零)
//   A = team_status     (0 未报名 / 1 初筛 / 2 复筛 / 3 终筛)
//   B = approval_status (0 待审 / 1 通过 / 2 拒绝)
//   C = 是否跳过 step2/3/4 校验 (0 否 / 1 是)
//     C=1 时, step2/3/4 校验函数被旁路, step4 不调 submitApply, 直接落到 step5
// 例: ?mockApply=001 未报名 + 跳过校验看完整流程; 110 初筛通过; 320 终筛拒绝
//
// 不满足触发条件时返回 null, 调用方判断为 falsy 即走原业务流程, 副作用完全收敛在此模块。

const TEST_HOSTS = new Set(['localhost', '127.0.0.1'])

export function readApplyMock() {
  if (typeof window === 'undefined') return null
  if (!TEST_HOSTS.has(window.location.hostname)) return null
  const raw = new URLSearchParams(window.location.search).get('mockApply')
  if (!raw || !/^\d{1,3}$/.test(raw)) return null
  const padded = raw.padStart(3, '0')
  return {
    teamStatus: Number(padded[0]),
    approvalStatus: Number(padded[1]),
    bypassValidate: padded[2] === '1'
  }
}

// 把 mock 状态合并进 reqApplyInfo 接口返回的数据
export function withMockedApplyStatus(data, mock) {
  if (!mock) return data
  return { ...data, team_status: mock.teamStatus, approval_status: mock.approvalStatus }
}